<template>
    <div>
        <v-navigation-drawer v-model="drawer" app class="primary">
            <v-layout column align-center>
                <v-flex class="mt-5">
                    <p v-if="!currentUser" class="white--text subheading mt-1">
                        IT HELPDESK
                    </p>
                    <p v-else class="white--text subheading mt-1">
                        {{ currentUser.hdType }} HELPDESK
                    </p>

                </v-flex>
            </v-layout>
            <v-list dense>

                <v-list-item @click="viewIssues()"  >
                    <v-list-item-action>
                        <v-icon class="white--text">report_problem</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">ISSUES</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item dense v-for="link in links" :key="link.text" router :to="link.route">
                    <v-list-item-action>
                        <v-icon class="white--text">{{ link.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


            </v-list>
            <v-list v-if="currentUser && (currentUser.userType == 'admin' || currentUser.userType == 'assignee')">

                <v-list-item v-for="link in adminLinks" :key="link.text" router :to="link.route">
                    <v-list-item-action>
                        <v-icon class="white--text">{{ link.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>

    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props:['drawer'],
    data(){
        return {
            links:[
            ],
            adminLinks:[
                {icon:'people_alt',text:'Users',route:'/users'},
                {icon:'people_alt',text:'Assignees',route:'/assignees'},
                {icon:'people_alt',text:'Issues History',route:'/issueshistory'},

                {icon:'report_problem',text:'Issues Master',route:'/issuesMaster'},
                {icon:'report_problem',text:'Issue Types',route:'/issueTypes'},
                {icon:'report_problem',text:'Issue Subtypes',route:'/issueSubtypes'},
                {icon:'report_problem',text:'Solutions',route:'/solutions'},
                {icon:'report_problem',text:'Solution Types',route:'/solutionTypes'},
                {icon:'report_problem',text:'Diagnostics',route:'/diagnostics'},
                {icon:'report_problem',text:'Diagnostic Types',route:'/diagnosticTypes'},
                {icon:'report_problem',text:'Locations',route:'/locations'},
                {icon:'report_problem',text:'Departments',route:'/departments'},
                {icon:'report_problem',text:'Sections',route:'/sections'},
                {icon:'report_problem',text:'Issue Status',route:'/issue-status'},
                {icon:'report_problem',text:'Problem Sources',route:'/problem-sources'},
                {icon:'report_problem',text:'Accountable Persons',route:'/accountable-persons'},

            ]

        }
    },
    computed:{
        ...mapState(['currentUser']),
    },
    methods:{
        viewIssues(){

            if (!this.currentUser ){
                this.$router.push('/')
                return
            }
            this.$router.push('/issues')
            /*
            if (this.$store.state.currentUser.userType == 'client'){
                this.$router.push('/client')
            }if (this.$store.state.currentUser.userType == 'assignee'){
                this.$router.push('/assignee')
            }else if (this.$store.state.currentUser.userType == 'admin'){
                this.$router.push('/issues')
            }
            */
        },
        viewUsers(){

            if (!this.currentUser ){
                this.$router.push('/')
                return
            }

            if (this.currentUser.userType == 'admin' || this.currentUser.userType == 'assignee'){
                this.$router.push('/users')
            }
            
        },

        viewSolutions(){

            if (!this.currentUser ){
                this.$router.push('/')
                return
            }

            if (this.currentUser.userType == 'admin' || this.currentUser.userType == 'assignee'){
                this.$router.push('/solutions')
            }
            
        }

    },
    mounted(){
        //console.log("NavDraw mounted")
        //console.log("his.currentUser",this.currentUser)
        if (!this.currentUser ){
            this.$router.push('/')
        }

    }
}
</script>